<template>
    <BreadCrumb PageTitle="Soumettre un devoir" />
    <SubmitDevoir />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import SubmitDevoir from "../../components/Devoir/SubmitDevoir.vue";
  
    export default defineComponent({
      name: "SubmitDevoirPage",
      components: {
        BreadCrumb,
        SubmitDevoir,
      },
    });
  </script>